import type { EntryPoint } from '#packages/apilib';
import { EditorAPIKey, WixCodeApiKey } from '#packages/apis';
import { createWixCodeApi } from './wixCode';

export const WixCodeEntrypoint: EntryPoint = {
  name: 'WixCodeApi',
  declareAPIs: () => [WixCodeApiKey],
  getDependencyAPIs: () => [EditorAPIKey],
  attach(shell) {
    shell.contributeAPI(WixCodeApiKey, () => createWixCodeApi(shell));
  },
};
